// added referer in case its invite page, requires for resctriction of login/signup with organization domain as personal acc

const addRefererToBodyRequest = (body) => {
  if (
    window.location.href.includes("/sub-user-complete/") ||
    window.location.href.includes("/invite/")
  ) {
    body.referer = window.location.href;
  }
};

export default addRefererToBodyRequest;
